import { render, staticRenderFns } from "./PaymentModeItem.vue?vue&type=template&id=5c1443fe&"
import script from "./PaymentModeItem.vue?vue&type=script&lang=js&"
export * from "./PaymentModeItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports